import React from 'react';

export const Image = (
  props: React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement> & { fetchpriority?: 'high' | 'low' | 'auto' },
    HTMLImageElement
  >,
) => {
  return <img {...props} onContextMenu={(e) => e.preventDefault()} />;
};
